// Define this helper function outside of the component or outside of useCallback
export const cleanAddress = (address) => {
    return (address || "")
        .replace(/\./g, " ") // replace all periods with a single space.
        .replace(/\s\s+/g, " ") // consolidate ALL multiple spaces (including new ones) into a single space.
        .trim(); // remove leading/trailing spaces (important if period was first or last character).
};
